console.log('c4 v0.0.1')

import React from 'react'
import { render } from 'react-dom'
import App from './App'

render(<App />, document.querySelector('.app'))
